let baseURL = 'http://127.0.0.1:8000';
if (process.env.NODE_ENV === 'production') {
    baseURL = 'https://dislog.hpc-hamburg.de';
}

let websocketURL = 'ws://127.0.0.1:8081';
if (process.env.NODE_ENV === 'production') {
  websocketURL = 'wss://dislog.hpc-hamburg.de';
}

let QLIK_TENANT = 'dislog.de.qlikcloud.com';
let QLIK_WEBINTEGRATIONID = 'ZhIuJAk61EHbKissqQplMdTio5mEZDND';
let QLIK_APPID_BI = '9c710c12-3a91-4b1b-a9ad-e2d45b75bfc8';
let QLIK_SHEETID_BI = 'f9d79074-ac54-479f-9b66-7374c31fb363';
let QLIK_APPID_AI = '840fd21d-07f5-4bdf-90ae-e2c563c67bea';
let QLIK_SHEETID_AI = 'cfc822ab-e500-4609-80dd-fbfd22f1da03';
let QLIK_APPID_MARKETANALYZER = '77a24192-fdfe-4d2f-be33-30e594cc9ac8';
let QLIK_SHEETID_MARKETANALYZER = 'bf190ed6-5457-4889-aeea-4cb20718c033';

export default {
  baseURL: baseURL,
  websocketURL: websocketURL,
  QLIK_TENANT: QLIK_TENANT,
  QLIK_WEBINTEGRATIONID: QLIK_WEBINTEGRATIONID,
  QLIK_APPID_BI: QLIK_APPID_BI,
  QLIK_SHEETID_BI: QLIK_SHEETID_BI,
  QLIK_APPID_AI: QLIK_APPID_AI,
  QLIK_SHEETID_AI: QLIK_SHEETID_AI,
  QLIK_APPID_MARKETANALYZER: QLIK_APPID_MARKETANALYZER,
  QLIK_SHEETID_MARKETANALYZER: QLIK_SHEETID_MARKETANALYZER
};